export const sidebarOpen = state => state.sidebarOpen;

export const notificationTotal = state => state.notifications.total;
